<template>
    <div>
        <v-dialog v-model="open" persistent max-width="600">
            <v-card>
                <v-toolbar :elevation="0" color="primary" dark>
                    <v-toolbar-title v-if="id">Editar Planta</v-toolbar-title>
                    <v-toolbar-title v-else>Añadir medidores</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon @click="close">
                        <v-icon>mdi-close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-title class="headline"> </v-card-title>
                <v-card-text>
                    <v-form ref="form" class="text-center">
                        <v-card flat>
                            <v-card-text>
                                <v-row>
                                    <v-col cols="5">
                                        <v-text-field
                                            v-model="gateway.id"
                                            label="Dispositivo"
                                            :disabled="verify"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="5">
                                        <v-text-field
                                            v-model="gateway.key"
                                            label="Llave"
                                            :disabled="verify"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col cols="2">
                                        <v-btn :loading="loading.verify" block color="accent" :disabled="verify" @click="verifyGateway">
                                            <v-icon>mdi-check</v-icon>
                                        </v-btn>
                                    </v-col>
                                </v-row> 
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.name"
                                            label="Nombre del circuito"
                                            :disabled="!verify"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.description"
                                            label="Descripción del circuito"
                                            :disabled="!verify"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pb-0">
                                        <v-text-field
                                            v-model="data.location"
                                            label="Coordenadas"
                                            :disabled="!verify"
                                            hint="Ejemplo: 25.661483,-100.399966"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            @blur="findAddress"
                                        ></v-text-field>
                                    </v-col>
                                    <v-col class="pb-0">
                                        <v-select
                                            v-model="data.rate"
                                            :items="rates"
                                            label="Tarifas"
                                            :disabled="!verify"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-select>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col class="pt-0">
                                        <v-text-field
                                            v-model="data.address"
                                            label="Dirección"
                                            :disabled="!verify"
                                            readonly
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <GmapMap
                                            :center="map.center || {
                                                lat: profile.location.latitude,
                                                lng: profile.location.longitude,
                                            }"
                                            :zoom="17"
                                            :options="{
                                                zoomControl: false,
                                                mapTypeControl: false,
                                                scaleControl: false,
                                                streetViewControl: false,
                                                rotateControl: false,
                                                fullscreenControl: false,
                                            }"
                                            map-type-id="roadmap"
                                            class="map"
                                        >

                                            <GmapMarker
                                                v-if="map.marker"
                                                :position="map.marker"
                                            />
                                            
                                        </GmapMap>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.panels"
                                            label="Numero de paneles"
                                            :disabled="!verify"
                                            type="number"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                    <v-col>
                                        <v-text-field
                                            v-model="data.inverters"
                                            label="Numero de inversores"
                                            :disabled="!verify"
                                            type="number"
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details
                                        ></v-text-field>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col>
                                        <template>
                                            <v-file-input 
                                            ref="image"
                                            v-model="data.image"
                                            accept="image/*" 
                                            label="Adjuntar foto"
                                            :disabled="!verify"
                                            prepend-inner-icon="mdi-image"
                                            filled
                                            prepend-icon=""
                                            outlined
                                            flat
                                            dense
                                            solo
                                            hide-details>
                                            </v-file-input>
                                        </template>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col v-if="meters.length > 0">
                                        <v-list dense outlined>
                                            <v-list-item v-for="meter in meters" :key="meter.name">
                                                <v-list-item-content class="text-left">
                                                    <v-list-item-title>{{ meter.name }}</v-list-item-title>
                                                    <v-list-item-subtitle>Key: {{ meter.key }}</v-list-item-subtitle>
                                                </v-list-item-content>
                                                <v-list-item-action>
                                                    <div class="d-block d-md-flex">
                                                        <v-chip 
                                                            :color="meter.type == 'consumption' ? 'accent' : ''"
                                                            @click="meter.type = 'consumption'"
                                                            outlined 
                                                            class="ma-1">
                                                            Consumo
                                                        </v-chip>
                                                        <v-chip 
                                                            :color="meter.type == 'generation' ? 'accent' : ''"
                                                            @click="meter.type = 'generation'"
                                                            outlined 
                                                            class="ma-1">
                                                            Generación
                                                        </v-chip>
                                                    </div>
                                                </v-list-item-action>
                                            </v-list-item>
                                        </v-list>
                                    </v-col>
                                </v-row>
                                <v-row>
                                    <v-col cols="12">
                                        <v-btn 
                                            v-if="id"
                                            :loading="loading.save"
                                            color="accent"
                                            block
                                            @click="edit">
                                            Guardar
                                        </v-btn>
                                        <v-btn 
                                            v-else
                                            :loading="loading.save" 
                                            color="accent" 
                                            block
                                            :disabled="
                                                data.name === '' ||
                                                data.address === '' ||
                                                data.location === '' ||
                                                data.inverters === null ||
                                                data.panels === null ||
                                                data.rate === null ||
                                                data.image === null ||
                                                meters.length === 0 ||
                                                meters.findIndex( m => m.type == null ) > -1
                                            "
                                            @click="save"
                                            >Guardar</v-btn>
                                    </v-col>
                                    <v-col cols="12">
                                        <v-btn
                                            color="blue-grey"
                                            text
                                            block
                                            @click="close"
                                            >Cancelar</v-btn>
                                    </v-col>
                                </v-row>
                            </v-card-text>
                        </v-card>
                    </v-form>
                </v-card-text>
            </v-card>
        </v-dialog>
        <v-snackbar v-model="error.active" :timeout="3000">
            {{ error.message }}
            <template v-slot:action="{ attrs }">
                <v-btn
                    color="error"
                    text
                    v-bind="attrs"
                    @click="error.active = false"
                >
                    Cerrar
                </v-btn>
            </template>
        </v-snackbar>
    </div>
</template>

<script>
import axios from 'axios'
import { gmapApi } from 'vue2-google-maps'
import { Gateway } from '../api'
import { mapActions, mapGetters, mapState } from 'vuex'

export default {
    name: 'formMeters',
    props: ['open', 'id'],
    computed:{
        google: gmapApi,
        ...mapGetters({ 
            getGateway: 'gateways/getGateway',
            getMeters: 'meters/getMetersGtw'
        }),
        ...mapState({ profile: state => state.account.profile })
    },
    data() {
        return {
            rates: [
                { text: 'Residencial', disabled: true },
                { text: '1' }, { text: '1A' },{ text: '1B' },{ text: '1C' },
                { text: '1D' },{ text: '1E' },{ text: '1F' },{ text: 'DAC' },
                { text: 'Comercial', disabled: true },
                { text: 'PDBT' },{ text: 'GDMT' },
                { text: 'Industrial', disabled: true },
                { text: 'GDMTH' },{ text: 'GDMTO' }
            ],
            verify: false,
            gateway: {
                id: '',
                key: ''
            },
            meters: [],
            data:{
                name: '', 
                description: '', 
                address: '',
                location: '',
                inverters: null,
                panels: null, 
                rate: null,
                image: null
            },
            map:{
                center: null,
                marker: null
            },
            loading:{
                verify: false,
                save: false
            },
            error: {
                message: '',
                active: false
            }
        }
    },
    methods: {
        ...mapActions({ 
            addGateway: 'gateways/addGateway',
            editGateway: 'gateways/editGateway',
            addMeters: 'meters/addMeters',
            editMeters: 'meters/editMeters'
        }),
        async verifyGateway(){
            if(this.gateway.id === '' || this.gateway.key === '') {
                this.error.message = 'Ingrese gateway y la key'
                this.error.active = true
                return
            }
            try {
                this.loading.verify = true
                let { data } = await Gateway.get({ 
                    id: this.gateway.id, 
                    key: this.gateway.key
                })
                this.meters = data.map( m => {
                    let type = m.name.indexOf('S') > -1  || m.name.indexOf('s') > -1 
                        ? 'generation' 
                        : m.name.indexOf('C') > -1 || m.name.indexOf('c') > -1
                            ? 'consumption'
                            : null
                    
                    return { ...m, type }
                } )
                this.verify = true
                this.loading.verify = false
            } catch (error) {
                if(error.response.status == 400){
                    this.error.message = 'Key invalida'
                    this.error.active = true
                }else if(error.response.status == 404){
                    this.error.message = 'Gateway no encontrado'
                    this.error.active = true
                }
                this.loading.verify = false
            }
        },
        async save(){
            try {
                this.loading.save = true
                await this.addGateway({
                    gateway: this.gateway,
                    data: {
                        ...this.data,
                        consumption: this.meters.reduce( (arr, m) => { 
                                m.type === 'consumption' ? arr.push(m.name): arr
                                return arr
                            }, []),
                        generation: this.meters.reduce( (arr, m) => { 
                                m.type === 'generation' ? arr.push(m.name): arr
                                return arr
                            }, []),
                    },
                    meters: this.meters
                })
                await this.addMeters({
                    meters: this.meters,
                    gateway: this.gateway.id
                })
                this.loading.save = true
            } catch (error) {
                console.log(error)
            }
            
            this.close()
        },
        async edit(){
            try {
                this.loading.save = true
                await this.editGateway({
                    gateway: this.gateway,
                    data: {
                        ...this.data,
                        consumption: this.meters.reduce( (arr, m) => { 
                                m.type === 'consumption' ? arr.push(m.name): arr
                                return arr
                            }, []),
                        generation: this.meters.reduce( (arr, m) => { 
                                m.type === 'generation' ? arr.push(m.name): arr
                                return arr
                            }, []),
                    },
                    meters: this.meters
                })
                await this.editMeters({
                    meters: this.meters,
                    gateway: this.gateway.id
                })
                this.loading.save = true
            } catch (error) {
                console.log(error)
            }
            
            this.close()
        },
        findAddress(){
            try {
                if(this.data.location === '') return
                let coordinates = this.data.location.split(',').map( l => parseFloat(l))
                if(coordinates.some(isNaN) || coordinates.length !== 2) {
                    this.map.marker = null
                    this.map.center = null
                    this.data.address = ''
                }

                const geocoder = new this.google.maps.Geocoder()
                const latlng = {
                    lat: coordinates[0],
                    lng: coordinates[1],
                }
                geocoder.geocode({location: latlng}, (result, status) => {
                    if(status === 'OK'){
                        this.map.marker = latlng
                        this.map.center = latlng
                        this.data.address = result[0].formatted_address
                    }
                })

            } catch (error) {
                console.log(error)
            }
        },
        close(){
            this.reset()
            this.$emit('close')
        },
        reset(){
            this.verify = false
            this.gateway = {
                id: '',
                key: ''
            }
            this.data = {
                name: '', 
                description: '', 
                address: '',
                location: '',
                inverters: null,
                panels: null, 
                rate: null,
                image: null
            }
            this.map = {
                center: null,
                marker: null
            }
            this.meters = []
            this.loading = {
                verify: false,
                save: false
            }
        }
    },
    watch:{
        id(){
            if(this.id){
                const gtw = this.getGateway(this.id)
                this.meters = this.getMeters(this.id)

                this.gateway.id = gtw.id
                this.gateway.key = gtw.key
                this.verify = true
                this.data.name = gtw.name
                this.data.description = gtw.description
                this.data.address = gtw.address
                this.data.location = `${gtw.location.latitude},${gtw.location.longitude}`
                this.data.inverters = gtw.inverters
                this.data.panels = gtw.panels
                this.data.rate = gtw.rate

                const latlng = {
                    lat: gtw.location.latitude,
                    lng: gtw.location.longitude,
                }
                this.map.marker = latlng
                this.map.center = latlng

            }
        }
    }
}
</script>

<style scoped>
.map{
    height: 150px;
    width: 100%;
}
</style>